import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import ContentCard from "../../common/template/contentCard";
import ContentCardHeader from "../../common/template/contentCardHeader";
import ContentCardBody from "../../common/template/contentCardBody";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import Button from "../../common/button/button";
import Select from "../../common/form/select";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import * as am4core from "@amcharts/amcharts4/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import NumberFormat from "react-number-format";
import { getDemanda, getListaGraficoConsumoAnual, getListaGraficoConsumoPorUnidadeAcumuladoAno, getListaConsumoPorUnidadePeriodo, setFiltro } from "../analiseActions";
import { montarGraficoLineMensal } from "../../common/graficos/montarGraficoLineMensal.js";
import { montarGraficoHorizontalStackedBar } from "../../common/graficos/montarGraficoHorizontalStackedBar.js";
import { montarGraficoLineMensalSafra } from "../../common/graficos/montarGraficoLineMensalSafra.js";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar.js";
import { ModalAlert } from "../../common/dialog/modalAlert.jsx";
import { gerarRelatorio, setListaFaturasRedirecionamento } from "../../fatura/faturaActions.js";
import { Loading } from "../../common/loading/loading";
import { convertToBase64 } from "../../utils/convertToBase64.js";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox.jsx";
import AlertIcon from "../../common/alertIcon/alertIcon.jsx";
import { setInfo } from "../../common/toast/toast.jsx";
import { montarGraficoGroupStackedColumn } from "../../common/graficos/montarGraficoGroupStackedColumn.js";
import Toggle from "../../common/form/toggle.jsx";
import { ModalFaturasNaoImportadas } from "../components/ModalFaturasNaoImportadas.jsx";

function analiseConsumo(props) {
    if (!props.visible) return null;
    const {
        state,
        listar,
        contratoDemanda,
        listaGraficoConsumoAnual,
        listaConsumoPorUnidadePeriodo,
        listaGraficoConsumoPorUnidadeAcumuladoAno,
        filtro,
        usuarioLogado,
        getDemanda,
        getListaGraficoConsumoAnual,
        getListaConsumoPorUnidadePeriodo,
        getListaGraficoConsumoPorUnidadeAcumuladoAno,
        setAguardando,
        setFiltro,
        listaAnos,
        gerarRelatorio,
        setListaFaturasRedirecionamento,
        listaUnidadeConsumidora,
    } = props;

    const contentCardRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [modalExportacaoAberto, setModalExportacaoAberto] = useState(false);
    const [listaModalFaturasSemImportacao, setListaModalFaturasSemImportacao] = useState([]);
    const [graficoConsumoAnual, setGraficoConsumoAnual] = useState(null);
    const [graficoConsumoMensal, setGraficoConsumoMensal] = useState(null);
    const [graficoConsumoPorUnidadeAcumuladoAno, setGraficoConsumoPorUnidadeAcumuladoAno] = useState(null);
    const [listaConsumoEditavel, setListaConsumoEditavel] = useState([]);
    const [considerarConsumoInstantaneoTabelaComparativa, setConsiderarConsumoInstantaneoTabelaComparativa] = useState(false);

    useEffect(() => {
        atualizarTodosGraficos();
        return desmontarTodosGraficos;
    }, []);

    useEffect(() => {
        const buscarDados = async () => {
            if (!state.aguardando) return;

            await Promise.all([getDemanda(), getListaGraficoConsumoAnual(), getListaConsumoPorUnidadePeriodo(), getListaGraficoConsumoPorUnidadeAcumuladoAno()]);

            setAguardando(false);
        };

        buscarDados();
        if (!state.aguardando) {
            atualizarTodosGraficos();
        }
    }, [state.aguardando]);

    function atualizarTodosGraficos() {
        atualizarListaGraficoConsumoAnual();
        atualizarListaGraficoConsumoPorUnidadeAcumuladoAno();
    }
    function desmontarTodosGraficos() {
        if (graficoConsumoAnual) graficoConsumoAnual.dispose();
        if (graficoConsumoMensal) graficoConsumoMensal.dispose();
        if (graficoConsumoPorUnidadeAcumuladoAno) graficoConsumoPorUnidadeAcumuladoAno.dispose();
    }

    function atualizarListaGraficoConsumoAnual() {
        const dados = [];
        listaGraficoConsumoAnual.forEach((mes) => {
            mes.anos.forEach((itemAno) => {
                const itemExiste = dados.find((item) => item.ano == itemAno.ano);
                if (!itemExiste) {
                    dados.push({
                        ano: "" + itemAno.ano,
                        consumo: parseFloat(itemAno.consumo_fatura) || 0,
                        consumo_instantaneo: parseFloat(itemAno.consumo_instantaneo) || 0,
                    });
                } else {
                    itemExiste.consumo += parseFloat(itemAno.consumo_fatura) || 0;
                    itemExiste.consumo_instantaneo += parseFloat(itemAno.consumo_instantaneo) || 0;
                }
            });
        });
        dados.sort((a, b) => String(a.ano).substring(0, 4) - String(b.ano).substring(0, 4));

        const valuesAndNames = [{ value: "consumo", name: "Na Fatura", stacked: true, linePattern: false }];
        const ucsFiltro = listaUnidadeConsumidora.filter((uc) =>
            filtro.unidades_consumidoras.length ? filtro.unidades_consumidoras.find((ucf) => ucf.value == uc.id) : uc.id_cliente == filtro.id_cliente
        );
        const temGeradoraNoFiltro = ucsFiltro.find((uc) => uc.geracao);

        if (temGeradoraNoFiltro) {
            valuesAndNames.push({ value: "consumo_instantaneo", name: "Consumo Instantâneo", stacked: true, linePattern: false });
        }

        const graficoConsumoAnualAtualizado = montarGraficoGroupStackedColumn({
            state: {
                cores: [am4core.color("#009de6"), am4core.color("#4e2dee")],
            },
            component: graficoConsumoAnual,
            nome: "graficoConsumoAnual",
            dados,
            category: "ano",
            valuesAndNames,
            titulo: `Consumo Total (kWh)`,
            fontSizeTitle: 18,
            fontWeightTitle: "bolder",
            prefixo: "",
            sufixo: "kWh",
            positionBullet: 0,
            dimensions: "3D",
            mostrarLegenda: temGeradoraNoFiltro,
            chartBackground: "#30303d",
            bullets: true,
            nameSerieBullets: "Na Fatura",
            dxIcone: 25,
            hideExport: true,
            centralizarVerticalmente: true,
            exibirBulletTotalizadorSeries: temGeradoraNoFiltro,
        });

        setGraficoConsumoAnual(graficoConsumoAnualAtualizado);

        //atualiza a lista quando altera os valores, para recalcular a sazonalidade com os valores simulados
        setListaConsumoEditavel([...listaGraficoConsumoAnual]);

        const montarGraficoMensal = filtro.consumo_ano_safra ? montarGraficoLineMensalSafra : montarGraficoLineMensal;
        const graficoConsumoMensalAtualizado = montarGraficoMensal({
            state,
            component: graficoConsumoMensal,
            nome: "graficoConsumoMensal",
            dados: listaGraficoConsumoAnual,
            titulo: "Consumo Mensal (kWh)",
            prefixo: "",
            sufixo: "kWh",
            nomeCampo: "consumo_fatura",
        });
        setGraficoConsumoMensal(graficoConsumoMensalAtualizado);
    }

    function atualizarListaGraficoConsumoPorUnidadeAcumuladoAno() {
        const lista = [...listaGraficoConsumoPorUnidadeAcumuladoAno].sort((a, b) => a.consumo_fatura - b.consumo_fatura);
        const graficoConsumoPorUnidadeAcumuladoAnoAtualizado = montarGraficoHorizontalStackedBar({
            cores: [am4core.color("#009de6"), am4core.color("#4e2dee")],
            component: graficoConsumoPorUnidadeAcumuladoAno,
            chartDivId: "graficoConsumoPorUnidadeAcumuladoAno",
            category: "agrupador",
            valuesAndNames: [
                { value: "consumo_fatura", name: "Na Fatura", stacked: true },
                { value: "consumo_instantaneo", name: "Consumo Instantâneo", stacked: true },
            ],
            bullets: true,
            campoSetVisible: "unidade_geradora",
            lista,
            titulo: `Consumo Acumulado ${filtro.consumo_ano_safra ? "Período Safra" : "Anual"} por UC (kWh)`,
            prefixo: "",
            sufixo: "kWh",
        });
        setGraficoConsumoPorUnidadeAcumuladoAno(graficoConsumoPorUnidadeAcumuladoAnoAtualizado);
    }

    function renderizarCelulasComZeros(corCiclo, listaDados) {
        let listaMeses = [];
        for (let i = listaDados.length; i < 12; i++) {
            listaMeses.push(i);
        }

        return listaMeses.map((mes) => (
            <Td key={mes} alignCenter color="#fff" backgroundColor={corCiclo}>
                0
            </Td>
        ));
    }
    function bloquearScroll(e) {
        e.preventDefault();
    }

    function toggleScroll(bloquear) {
        if (bloquear) {
            document.body.style.overflowY = "hidden";
            window.addEventListener("wheel", bloquearScroll, { passive: false });
            window.addEventListener("touchmove", bloquearScroll, { passive: false });
        } else {
            document.body.style.overflowY = "auto";
            window.removeEventListener("wheel", bloquearScroll);
            window.removeEventListener("touchmove", bloquearScroll);
        }
    }

    function calcularComparativo(item) {
        let comparativo = parseFloat(item.valor_atual) > 0 && parseFloat(item.valor_anterior) > 0 ? (parseFloat(item.valor_atual) * 100) / parseFloat(item.valor_anterior) : 0;
        if (comparativo > 0) {
            comparativo = comparativo - 100;
        }
        return comparativo;
    }

    async function handleExport({ graficosAtivos, quantidadeAnos, quantidadeUCs }) {
        const ALTURA_MAX_CONTEUDO = 84;
        const MARGIN_MAXIMA = 20;
        const condicaoGraficoPaginaInteira = quantidadeUCs > 20;
        const condicao3PorPagina = quantidadeUCs <= 7;
        const graficosPorPaginaEmFuncaoDeQuantidadeUCs = condicaoGraficoPaginaInteira ? 1 : condicao3PorPagina ? 3 : 2;

        setLoading(true);
        toggleScroll(true);
        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };
        const calcularWidthGrafico = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.zoom = "0.70"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1200 - desconto + "px";
            } else {
                el.style.width = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
                if (getTamanhoBase() == 2500) {
                    el.style.paddingLeft = "70px";
                    el.style.width = 1180 - desconto + "px";
                }
                if (getTamanhoBase() == 4900) {
                    el.style.paddingLeft = "120px";
                    el.style.width = 1105 - desconto + "px";
                }
            }
        };

        const calcularWidthTabela = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.fontSize = "0.7rem";
                el.style.zoom = "0.60"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1500 - desconto + "px";
            } else {
                el.style.minWidth = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
            }
        };

        const formatarGrafico = ({ el }) => {
            if (el) {
                el.style.fontSize = "0.8rem";
                calcularWidthGrafico({ el });
                el.style.backgroundColor = "#30303d";
                el.style.overflowY = "hidden";
                const titulo = el.querySelectorAll("tspan");
                titulo.forEach((el, i) => {
                    if (el.textContent.includes("Consumo")) {
                        el.style.marginTop = "3rem";
                        el.style.fontSize = "1.6rem";
                        el.style.fontWeight = "bold";
                        el.setAttribute("x", el.textContent.length * 4 + "px"); // centraliza no meio do SVG
                        el.setAttribute("text-anchor", "middle");
                    }
                });
            }
        };
        const formatarTabela = ({ el, heightCelula }) => {
            if (el) {
                calcularWidthTabela({ el });
                el.style.color = "#FFFFFF";
                el.style.backgroundColor = "#30303d";
                el.style.paddingTop = "50px";
                el.style.paddingBottom = "50px";
                el.style.borderCollapse = "collapse";
                el.style.border = "1px solid #666682";

                // Aplica bordas também às células (th, td)
                const celulas = el.querySelectorAll("th, td");
                celulas.forEach((celula) => {
                    if (heightCelula) {
                        celula.style.height = heightCelula;
                    }
                    celula.style.border = "1px solid #666682";
                    celula.style.padding = "8px"; // Adiciona padding para melhorar a aparência
                    celula.style.textAlign = "left";

                    // Remove botões dentro do próprio td (fora da div filha)
                    celula.querySelectorAll("button").forEach((btn) => btn.remove());
                });
            }
        };
        const exibirTagOculta = ({ el, textAlign = "left", titulo = false }) => {
            if (el) {
                calcularWidthGrafico({ el, desconto: 20 });
                el.style.color = "#FFFFFF";
                el.style.fontSize = titulo ? "1.6rem" : "1rem";
                el.style.fontWeight = "bold";
                el.style.backgroundColor = "#30303d";
                el.style.visibility = "visible";
                el.style.marginBottom = "0px";
                el.style.marginTop = "10px";
                el.style.padding = "5px";
                el.style.textAlign = textAlign;
            }
        };

        if (contentCardRef.current) {
            // Altera a largura e cor de fundo do gráfico antes de renderizar o conteúdo
            const graficoConsumoAnual = contentCardRef.current.querySelector("#graficoConsumoAnual");
            const graficoConsumoMensal = contentCardRef.current.querySelector("#graficoConsumoMensal");
            const tabelaConsumoMensal = contentCardRef.current.querySelector("#tabelaConsumoMensal");
            const tituloTabelaComparativa = contentCardRef.current.querySelector("#tituloTabelaComparativa");
            const tabelaComparativa = contentCardRef.current.querySelector("#tabelaComparativa");
            const periodoConsumoPorUnidadeAcumuladoAno = contentCardRef.current.querySelector("#periodoConsumoPorUnidadeAcumuladoAno");
            const tabelaConsumoPorUnidadeAcumuladoAno = contentCardRef.current.querySelector("#tabelaConsumoPorUnidadeAcumuladoAno");

            const qtdLinhasTabela = 58;

            formatarGrafico({ el: graficoConsumoAnual });
            formatarGrafico({ el: graficoConsumoMensal });
            formatarTabela({ el: tabelaConsumoMensal });
            exibirTagOculta({ el: tituloTabelaComparativa, textAlign: "center", titulo: true });
            formatarTabela({ el: tabelaComparativa, marginTop: 0, heightCelula: quantidadeUCs > qtdLinhasTabela ? "3rem" : null });
            exibirTagOculta({ el: periodoConsumoPorUnidadeAcumuladoAno, titulo: true });
            formatarTabela({ el: tabelaConsumoPorUnidadeAcumuladoAno, heightCelula: quantidadeUCs > qtdLinhasTabela ? "3rem" : null });

            function calcularAlturaGraficosUC({ condicaoUltrapassaPaginas, quantidadeUCs, quantidadeLimite }) {
                const paginasOcupadasMesmoGrafico = Math.ceil(quantidadeUCs / quantidadeLimite);

                let alturaGraficosUC = ALTURA_MAX_CONTEUDO / graficosPorPaginaEmFuncaoDeQuantidadeUCs;

                if (condicaoUltrapassaPaginas) {
                    let total = 0;

                    for (let i = 0; i < paginasOcupadasMesmoGrafico; i++) {
                        //na primeira pagina soma mais 4% pra compensar a falta do rodapé
                        if (i == 0) {
                            total += ALTURA_MAX_CONTEUDO + 4;
                        } else if (i > 0 && i < paginasOcupadasMesmoGrafico - 1) {
                            //se é pagina do meia conta 100%, pq não tem cabeçalho nem rodapé
                            total += ALTURA_MAX_CONTEUDO + 16;
                        } else if (i == paginasOcupadasMesmoGrafico - 1) {
                            //na última pagina soma mais 10% pra compensar a falta do cabeçalho
                            total += ALTURA_MAX_CONTEUDO + 10;
                        }
                    }

                    alturaGraficosUC = total;
                }

                return alturaGraficosUC;
            }

            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="border: 1px solid #DDD; font-family: Arial, sans-serif;"><div style="width:100%; height:10%;">
                    <img src="${base64Cabecalho}" width="100%" />
                </div>`;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `<div style="width:100%; height:4%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                       <img src="${base64Rodape}" width="100%" />
                                   </div>
                               </div> `;

            // Captura o HTML com os estilos atualizados
            const htmlGraficoConsumoAnual =
                graficosAtivos.graficoConsumoAnual && graficoConsumoAnual
                    ? `<div style="width:100%; height:42%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoConsumoAnual.outerHTML +
                      "</div>"
                    : "";
            const htmlGraficoConsumoMensal =
                graficosAtivos.graficoConsumoMensal && graficoConsumoMensal && tabelaConsumoMensal
                    ? `<div style="width:100%; height:42%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoConsumoMensal.outerHTML +
                      tabelaConsumoMensal.outerHTML +
                      "</div>"
                    : "";

            const marginGraficosUC = `${MARGIN_MAXIMA / graficosPorPaginaEmFuncaoDeQuantidadeUCs}px`;
            const alinhamentoVertical = condicaoGraficoPaginaInteira ? "flex-start" : "center";

            const htmlTabelaComparativa =
                graficosAtivos.tabelaComparativa && tituloTabelaComparativa && tabelaComparativa
                    ? `<div style="width:100%; height:${calcularAlturaGraficosUC({
                          condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                          quantidadeUCs,
                          quantidadeLimite: qtdLinhasTabela,
                      })}%; display:flex; flex-direction:column; align-items:center; justify-content:${alinhamentoVertical}; margin-bottom:${marginGraficosUC}; background-color:#30303d">` +
                      tituloTabelaComparativa.outerHTML +
                      tabelaComparativa.outerHTML +
                      "</div>"
                    : "";
            const htmlGraficoConsumoPorUnidadeAcumuladoAno =
                graficosAtivos.graficoConsumoPorUnidadeAcumuladoAno && periodoConsumoPorUnidadeAcumuladoAno && tabelaConsumoPorUnidadeAcumuladoAno
                    ? `<div style="width:100%; height:${calcularAlturaGraficosUC({
                          condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela,
                          quantidadeUCs,
                          quantidadeLimite: qtdLinhasTabela,
                      })}%; display:flex; flex-direction:column; align-items:center; justify-content:${alinhamentoVertical}; margin-bottom:${marginGraficosUC}; background-color:#30303d">` +
                      periodoConsumoPorUnidadeAcumuladoAno.outerHTML +
                      tabelaConsumoPorUnidadeAcumuladoAno.outerHTML +
                      "</div>"
                    : "";

            //valida graficos pequenos que cabe 3 por pagina
            const graficos = [
                { h: 42, el: htmlGraficoConsumoAnual },
                { h: 42, el: htmlGraficoConsumoMensal },
                {
                    h: calcularAlturaGraficosUC({ condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela, quantidadeUCs, quantidadeLimite: qtdLinhasTabela }),
                    el: htmlTabelaComparativa,
                },
                {
                    h: calcularAlturaGraficosUC({ condicaoUltrapassaPaginas: quantidadeUCs > qtdLinhasTabela, quantidadeUCs, quantidadeLimite: qtdLinhasTabela }),
                    el: htmlGraficoConsumoPorUnidadeAcumuladoAno,
                },
            ].filter((g) => g.el);

            if (!graficos.length) {
                setLoading(false);
                toggleScroll(false);
                return;
            }

            const listaPaginas = [];
            for (const g of graficos) {
                if (!listaPaginas.length) {
                    listaPaginas.push({
                        indice: listaPaginas.length,
                        alturaAcumulada: g.h,
                        graficos: [g.el],
                    });
                } else {
                    const ultimaPaginaIncluida = listaPaginas[listaPaginas.length - 1];
                    if (ultimaPaginaIncluida.alturaAcumulada + g.h > ALTURA_MAX_CONTEUDO) {
                        listaPaginas.push({
                            indice: listaPaginas.length,
                            alturaAcumulada: g.h,
                            graficos: [g.el],
                        });
                    } else {
                        ultimaPaginaIncluida.alturaAcumulada += g.h;
                        ultimaPaginaIncluida.graficos.push(g.el);
                    }
                }
            }

            let html = "";

            listaPaginas.forEach((pagina) => {
                html += htmlCabecalho;
                pagina.graficos.forEach((grafico) => {
                    html += grafico;
                });
                if (pagina.alturaAcumulada < ALTURA_MAX_CONTEUDO) {
                    html += `<div style="width:100%; height:${ALTURA_MAX_CONTEUDO - pagina.alturaAcumulada}%"></div>`;
                }
                html += htmlRodape;
            });
            // Gera o relatório com o HTML atualizado
            await gerarRelatorio({
                html,
                landscape: false,
                scale: window.innerWidth < 768 ? 0.62 : window.devicePixelRatio * 0.4,
            });
            toggleScroll(false);
            setLoading(false);
        } else {
            console.error("ContentCard não está acessível.");
        }
    }

    function renderizarCabecalhoMeses({ ucFiltradaSazonal, demandaMesInicial, demandaMesFinal }) {
        const janeiroAteMaio = (
            <>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "01" ? "#66bb6a" : demandaMesFinal == "01" ? "#ef5350" : null) : null,
                    }}
                >
                    Janeiro
                    {ucFiltradaSazonal ? (demandaMesInicial == "01" ? " (I)" : demandaMesFinal == "01" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "02" ? "#66bb6a" : demandaMesFinal == "02" ? "#ef5350" : null) : null,
                    }}
                >
                    Fevereiro
                    {ucFiltradaSazonal ? (demandaMesInicial == "02" ? " (I)" : demandaMesFinal == "02" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "03" ? "#66bb6a" : demandaMesFinal == "03" ? "#ef5350" : null) : null,
                    }}
                >
                    Março
                    {ucFiltradaSazonal ? (demandaMesInicial == "03" ? " (I)" : demandaMesFinal == "03" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "04" ? "#66bb6a" : demandaMesFinal == "04" ? "#ef5350" : null) : null,
                    }}
                >
                    Abril
                    {ucFiltradaSazonal ? (demandaMesInicial == "04" ? " (I)" : demandaMesFinal == "04" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "05" ? "#66bb6a" : demandaMesFinal == "05" ? "#ef5350" : null) : null,
                    }}
                >
                    Maio
                    {ucFiltradaSazonal ? (demandaMesInicial == "05" ? " (I)" : demandaMesFinal == "05" ? " (F)" : "") : ""}
                </Th>{" "}
            </>
        );
        const junhoAteDez = (
            <>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "06" ? "#66bb6a" : demandaMesFinal == "06" ? "#ef5350" : null) : null,
                    }}
                >
                    Junho
                    {ucFiltradaSazonal ? (demandaMesInicial == "06" ? " (I)" : demandaMesFinal == "06" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "07" ? "#66bb6a" : demandaMesFinal == "07" ? "#ef5350" : null) : null,
                    }}
                >
                    Julho
                    {ucFiltradaSazonal ? (demandaMesInicial == "07" ? " (I)" : demandaMesFinal == "07" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "08" ? "#66bb6a" : demandaMesFinal == "08" ? "#ef5350" : null) : null,
                    }}
                >
                    Agosto
                    {ucFiltradaSazonal ? (demandaMesInicial == "08" ? " (I)" : demandaMesFinal == "08" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "09" ? "#66bb6a" : demandaMesFinal == "09" ? "#ef5350" : null) : null,
                    }}
                >
                    Setembro
                    {ucFiltradaSazonal ? (demandaMesInicial == "09" ? " (I)" : demandaMesFinal == "09" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "10" ? "#66bb6a" : demandaMesFinal == "10" ? "#ef5350" : null) : null,
                    }}
                >
                    Outubro
                    {ucFiltradaSazonal ? (demandaMesInicial == "10" ? " (I)" : demandaMesFinal == "10" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "11" ? "#66bb6a" : demandaMesFinal == "11" ? "#ef5350" : null) : null,
                    }}
                >
                    Novembro
                    {ucFiltradaSazonal ? (demandaMesInicial == "11" ? " (I)" : demandaMesFinal == "11" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "12" ? "#66bb6a" : demandaMesFinal == "12" ? "#ef5350" : null) : null,
                    }}
                >
                    Dezembro
                    {ucFiltradaSazonal ? (demandaMesInicial == "12" ? " (I)" : demandaMesFinal == "12" ? " (F)" : "") : ""}
                </Th>
            </>
        );

        return filtro.consumo_ano_safra ? (
            <>
                {junhoAteDez}
                {janeiroAteMaio}
            </>
        ) : (
            <>
                {janeiroAteMaio}
                {junhoAteDez}
            </>
        );
    }

    let ucFiltradaSazonal = false;
    let demandaAnoInicial = "";
    let demandaMesInicial = "";
    let demandaAnoFinal = "";
    let demandaMesFinal = "";
    let demandaCompetenciaInicial = "";
    let demandaCompetenciaFinal = "";
    let primeiroMesNaoSazonal = "";
    let primeiroAnoNaoSazonal = "";

    //se é não sazonal, pega os últimos 12 meses,
    const mesAtualDate = new Date().getMonth(); //não soma 1 pq o mes atual não deve ser contabilizado
    const anoAtual = String(new Date().getFullYear());
    //AQUI É A LÓGICA PARA PINTAR AS CÉLULAS DE CINZA
    if (contratoDemanda) {
        const mesLimite = mesAtualDate < 10 ? "0" + mesAtualDate : String(mesAtualDate);
        const mesesDescontar = Number(mesLimite) - 11; //diminui 11 meses para pegar o mes inicial dos últimos 12 meses
        const anoInicialCalculado = mesesDescontar > 0 ? anoAtual : anoAtual - 1; //se descontando 11 meses der negativo, considera ano anterior
        const mesInicialCalculado = Number(mesLimite) + 1 > 12 ? "01" : Number(mesLimite) + 1; //mes atual 10, inicia em 10+1 do ano anterior
        const competenciaInicialCalculada = Number(String(anoInicialCalculado) + String(mesInicialCalculado)); //usada pra comparar com competencia base
        //se competencia base for maior considera ela como inicial, senão considera a calculada
        const competenciaBaseSazonalidade =
            contratoDemanda.competencia_base_sazonalidade > competenciaInicialCalculada ? contratoDemanda.competencia_base_sazonalidade : competenciaInicialCalculada;

        ucFiltradaSazonal = contratoDemanda.unidade_consumidora_sazonal;
        demandaAnoInicial = ucFiltradaSazonal ? String(contratoDemanda.competencia_inicio).substring(0, 4) : String(competenciaBaseSazonalidade).substring(0, 4);
        demandaMesInicial = ucFiltradaSazonal ? String(contratoDemanda.competencia_inicio).substring(4, 6) : String(competenciaBaseSazonalidade).substring(4, 6);
        demandaAnoFinal = ucFiltradaSazonal ? String(contratoDemanda.competencia_fim).substring(0, 4) : anoAtual;
        demandaMesFinal = ucFiltradaSazonal ? String(contratoDemanda.competencia_fim).substring(4, 6) : mesLimite;
        demandaCompetenciaInicial = ucFiltradaSazonal ? parseInt(contratoDemanda.competencia_inicio) : competenciaBaseSazonalidade; //usado apenas no calculo de sazonalidade de uc Nao Sazonal
        demandaCompetenciaFinal = ucFiltradaSazonal ? parseInt(contratoDemanda.competencia_fim) : parseInt(`${anoAtual}${mesLimite}`);
        primeiroMesNaoSazonal = ucFiltradaSazonal ? "" : String(contratoDemanda.competencia_base_sazonalidade).substring(4, 6);
        primeiroAnoNaoSazonal = ucFiltradaSazonal ? "" : String(contratoDemanda.competencia_base_sazonalidade).substring(0, 4);
    }

    let corCiclo = "#30303d";

    let anosConsumo = [];
    listaGraficoConsumoAnual.forEach((item) => {
        item.anos.forEach((ano) => {
            const anoString = String(ano.ano);
            if (!anosConsumo.includes(anoString)) {
                anosConsumo.push(anoString);
            }
        });
    });

    // testa se na lista de anos (formato '2024' ou '2024/2025') inclui o ano de inicio ou fim da demanda
    if (demandaAnoInicial && !anosConsumo.find((ano) => String(ano).substring(0, 4).includes(demandaAnoInicial))) {
        const demandaAnoInicialFormatado = filtro.consumo_ano_safra ? `${demandaAnoInicial}/${parseInt(demandaAnoInicial) + 1}` : `${demandaAnoInicial}`;
        anosConsumo.push(demandaAnoInicialFormatado);
    }

    if (demandaAnoFinal && !anosConsumo.find((ano) => String(ano).substring(0, 4).includes(demandaAnoFinal))) {
        const demandaAnoFinalFormatado = filtro.consumo_ano_safra ? `${demandaAnoFinal}/${parseInt(demandaAnoFinal) + 1}` : `${demandaAnoFinal}`;
        anosConsumo.push(demandaAnoFinalFormatado);
    }

    anosConsumo = anosConsumo.sort((a, b) => parseInt(String(a).substring(0, 4)) - parseInt(String(b).substring(0, 4)));

    const quantidadeAnos = anosConsumo.length;
    const quantidadeUCs = listaGraficoConsumoPorUnidadeAcumuladoAno.length || 0;

    //ALTERA A LISTA PARA CONSIDERAR OU NÃO O CONSUMO INSTANTÂNEO
    const listaConsumoPorUnidadePeriodoAlterado = listaConsumoPorUnidadePeriodo.map((item) => {
        return considerarConsumoInstantaneoTabelaComparativa && item.unidade_geradora
            ? {
                  ...item,
                  valor_anterior: parseFloat(item.valor_anterior || 0) + parseFloat(item.consumo_instantaneo_anterior || 0),
                  valor_atual: parseFloat(item.valor_atual || 0) + parseFloat(item.consumo_instantaneo_atual || 0),
              }
            : item;
    });

    const objetoTotais = listaConsumoPorUnidadePeriodoAlterado.reduce(
        (objetoTotais, elemento) => {
            objetoTotais.valor_anterior += parseFloat(elemento.valor_anterior || 0);
            objetoTotais.valor_atual += parseFloat(elemento.valor_atual || 0);
            return objetoTotais;
        },
        { valor_anterior: 0, valor_atual: 0 }
    );

    const comparativoTotais = calcularComparativo(objetoTotais);

    return (
        <div ref={contentCardRef}>
            <ModalFaturasNaoImportadas
                listaModalFaturasSemImportacao={listaModalFaturasSemImportacao}
                usuarioLogado={usuarioLogado}
                handleClose={() => setListaModalFaturasSemImportacao([])}
                handleVerificarFaturas={async () => {
                    const { history } = props;
                    await setListaFaturasRedirecionamento(listaModalFaturasSemImportacao);
                    history.push("/fatura");
                }}
            />
            {loading ? (
                <>
                    <Loading />
                    <div style={{ height: "100vh", width: "100%" }}></div>
                </>
            ) : null}
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "scroll",
                    }}
                >
                    <Row alignRight style={{ paddingRight: 5 }}>
                        <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                style={{ width: window.innerWidth < 768 ? "50%" : 120 }}
                                text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Exportar</span>}
                                title="Exportar"
                                type={"light"}
                                icon={"fa fa-file-export"}
                                event={() => {
                                    if (!filtro.id_cliente) {
                                        return setInfo("Selecione um cliente e clique em atualizar antes de exportar");
                                    }
                                    setModalExportacaoAberto(true);
                                }}
                            />
                        </Grid>
                    </Row>
                    {modalExportacaoAberto ? (
                        <ModalAlert handleClose={() => setModalExportacaoAberto(false)} visibility={loading ? "hidden" : "visible"}>
                            <ExportAnalise quantidadeAnos={quantidadeAnos} quantidadeUCs={quantidadeUCs} />
                        </ModalAlert>
                    ) : null}
                    <div
                        id="graficoConsumoAnual"
                        style={{
                            width: "100%",
                            minWidth: "890px",
                            height: "400px",
                        }}
                    ></div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "scroll",
                    }}
                >
                    <div id="graficoConsumoMensal" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>{" "}
                    <div
                        style={{
                            minWidth: "890px",
                        }}
                    >
                        <Table responsive id="tabelaConsumoMensal">
                            <THead>
                                <Tr>
                                    <Th>Ano</Th>
                                    {renderizarCabecalhoMeses({ ucFiltradaSazonal, demandaMesInicial, demandaMesFinal })}
                                    <Th alignCenter>Sazonalidade</Th>
                                </Tr>
                            </THead>
                            <TBody>
                                {anosConsumo.map((anoOriginal) => {
                                    const anoCalculoIndiceSazonal = String(anoOriginal).substring(0, 4); //quando é safra pega só o ano antes da barra ex: 2023/2024, considera 2023

                                    return (
                                        <Tr key={anoOriginal}>
                                            <Td color="#fff">{anoOriginal}</Td>
                                            {listaGraficoConsumoAnual.map((mes) => {
                                                //quando é modo safra, se o mes for jun à dez, pega o ano antes da barra, se for de jan a maio pega o ano depois da barra (2024/2025), se não é safra pega o ano original (2024)
                                                const ano = filtro.consumo_ano_safra
                                                    ? parseInt(mes.mes) >= 6
                                                        ? `${String(anoOriginal).substring(0, 4)}`
                                                        : `${String(anoOriginal).substring(5)}`
                                                    : anoOriginal;
                                                const competenciaLinha = parseInt(`${ano}${mes.mes}`);
                                                const propsInicioNaoSazonalidade = {
                                                    title: mes.mes == primeiroMesNaoSazonal && ano == primeiroAnoNaoSazonal && !ucFiltradaSazonal ? "Primeiro mês Não Sazonal" : "",
                                                    style: {
                                                        border: mes.mes == primeiroMesNaoSazonal && ano == primeiroAnoNaoSazonal && !ucFiltradaSazonal ? "3px solid #00ff51" : null,
                                                    },
                                                };

                                                if (filtro.unidades_consumidoras.length == 1) {
                                                    if (ucFiltradaSazonal) {
                                                        corCiclo = mes.mes == demandaMesInicial ? (demandaAnoInicial == ano ? "#595967" : "#30303d") : corCiclo;
                                                    } else {
                                                        corCiclo =
                                                            competenciaLinha >= demandaCompetenciaInicial && competenciaLinha <= demandaCompetenciaFinal ? "#595967" : "#30303d";
                                                    }
                                                } else {
                                                    corCiclo = "#30303d";
                                                }
                                                //mes.anos = [{ano: 2020, mes: '12', valor: 2443.4},...]
                                                const anoMes = mes.anos.find((anoMes) => anoMes.ano == anoOriginal);
                                                if (anoMes) {
                                                    if (
                                                        anoMes.digitado ||
                                                        (competenciaLinha >= demandaCompetenciaInicial && competenciaLinha <= demandaCompetenciaFinal && !anoMes.consumo_fatura)
                                                    ) {
                                                        return (
                                                            <Td
                                                                {...propsInicioNaoSazonalidade}
                                                                key={`val${mes.mes}${anoMes.ano}`}
                                                                alignCenter
                                                                backgroundColor={corCiclo}
                                                                color="#fff"
                                                            >
                                                                <NumberFormat
                                                                    className="form-control"
                                                                    style={{
                                                                        textAlign: "center",
                                                                        maxWidth: 80,
                                                                        height: 20,
                                                                        fontSize: 13,
                                                                    }}
                                                                    placeholder={"0"}
                                                                    decimalSeparator={","}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={2}
                                                                    value={String(anoMes.consumo_fatura || "0,00").replace(".", ",")}
                                                                    onChange={(data) => {
                                                                        let lista = listaGraficoConsumoAnual.map((item) => {
                                                                            return {
                                                                                mes: item.mes,
                                                                                anos: item.anos.map((itemAno) => {
                                                                                    if (mes.mes == item.mes && itemAno.ano == anoMes.ano) {
                                                                                        return {
                                                                                            ...itemAno,
                                                                                            consumo_fatura: parseFloat(data.target.value.replace(",", ".")),
                                                                                        };
                                                                                    } else {
                                                                                        return itemAno;
                                                                                    }
                                                                                }),
                                                                            };
                                                                        });
                                                                        //atualiza a lista quando altera os valores, para recalcular a sazonalidade com os valores simulados
                                                                        setListaConsumoEditavel([...lista]);

                                                                        getListaGraficoConsumoAnual(lista);

                                                                        const graficoConsumoMensalAtualizado = montarGraficoLineMensal({
                                                                            state,
                                                                            component: graficoConsumoMensal,
                                                                            nome: "graficoConsumoMensal",
                                                                            dados: lista,
                                                                            titulo: "Consumo Mensal (kWh)",
                                                                            prefixo: "",
                                                                            sufixo: "kWh",
                                                                            nomeCampo: "consumo_fatura",
                                                                        });

                                                                        setGraficoConsumoMensal(graficoConsumoMensalAtualizado);
                                                                    }}
                                                                />
                                                            </Td>
                                                        );
                                                    } else {
                                                        return (
                                                            <Td {...propsInicioNaoSazonalidade} key={`${mes.mes}${anoMes.ano}`} alignCenter backgroundColor={corCiclo} color="#fff">
                                                                {parseFloat(anoMes.consumo_fatura || 0)
                                                                    .toFixed(0)
                                                                    .replace(".", ",")}
                                                            </Td>
                                                        );
                                                    }
                                                    // });
                                                } else {
                                                    if (competenciaLinha >= demandaCompetenciaInicial && competenciaLinha <= demandaCompetenciaFinal) {
                                                        return (
                                                            <Td {...propsInicioNaoSazonalidade} key={`dig${mes.mes}${ano}`} alignCenter backgroundColor={corCiclo} color="#fff">
                                                                <NumberFormat
                                                                    className="form-control"
                                                                    style={{
                                                                        textAlign: "center",
                                                                        maxWidth: 80,
                                                                        height: 20,
                                                                        fontSize: 13,
                                                                    }}
                                                                    placeholder={"0"}
                                                                    decimalSeparator={","}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={2}
                                                                    value={String(0 || "0,00").replace(".", ",")}
                                                                    onChange={(data) => {
                                                                        let lista = listaGraficoConsumoAnual.map((item) => {
                                                                            if (item.mes != mes.mes) {
                                                                                return item;
                                                                            } else {
                                                                                let anosAux = item.anos.map((itemAnoAux) => itemAnoAux);
                                                                                anosAux.push({
                                                                                    ano: filtro.consumo_ano_safra ? anoOriginal : ano,
                                                                                    mes: item.mes,
                                                                                    consumo_fatura: parseFloat(data.target.value.replace(",", ".")),
                                                                                    digitado: true,
                                                                                });

                                                                                return {
                                                                                    ...item,
                                                                                    anos: anosAux,
                                                                                };
                                                                            }
                                                                        });

                                                                        //atualiza a lista quando altera os valores, para recalcular a sazonalidade com os valores simulados
                                                                        setListaConsumoEditavel([...lista]);

                                                                        getListaGraficoConsumoAnual(lista);

                                                                        const graficoConsumoMensalAtualizado = montarGraficoLineMensal({
                                                                            state,
                                                                            component: graficoConsumoMensal,
                                                                            nome: "graficoConsumoMensal",
                                                                            dados: lista,
                                                                            titulo: "Consumo Mensal (kWh)",
                                                                            prefixo: "",
                                                                            sufixo: "kWh",
                                                                            nomeCampo: "consumo_fatura",
                                                                        });
                                                                        setGraficoConsumoMensal(graficoConsumoMensalAtualizado);
                                                                    }}
                                                                />
                                                            </Td>
                                                        );
                                                    } else {
                                                        return (
                                                            <Td {...propsInicioNaoSazonalidade} key={`dig${mes.mes}${ano}`} alignCenter backgroundColor={corCiclo} color="#fff">
                                                                0
                                                            </Td>
                                                        );
                                                    }
                                                }
                                            })}
                                            {renderizarCelulasComZeros(corCiclo, listaGraficoConsumoAnual)}
                                            <Td
                                                style={{ display: "flex", justifyContent: "space-around" }}
                                                color="#fff"
                                                backgroundColor={demandaAnoFinal == anoCalculoIndiceSazonal ? "#005662" : "#40838f"}
                                            >
                                                {contratoDemanda ? calcularSazonalidade({ anoCalculoIndiceSazonal }) : "-"}
                                            </Td>
                                        </Tr>
                                    );
                                })}
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ padding: 8 }}>
                <ContentCardHeader>
                    <Row>
                        <Grid cols="12 6 5 5">
                            <Row>
                                <Grid cols="12 12 12 12">
                                    <label>Período A</label>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="De"
                                            autoOk
                                            value={
                                                filtro.competencia_inicial_consumo_comparativo_antes
                                                    ? `${String(filtro.competencia_inicial_consumo_comparativo_antes).substring(0, 4)}/${String(
                                                          filtro.competencia_inicial_consumo_comparativo_antes
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_inicial_consumo_comparativo_antes: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="Até"
                                            autoOk
                                            value={
                                                filtro.competencia_final_consumo_comparativo_antes
                                                    ? `${String(filtro.competencia_final_consumo_comparativo_antes).substring(0, 4)}/${String(
                                                          filtro.competencia_final_consumo_comparativo_antes
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_final_consumo_comparativo_antes: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Row>
                        </Grid>
                        <Grid cols="12 6 5 5">
                            <Row>
                                <Grid cols="12 12 12 12">
                                    <label>Período B</label>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="De"
                                            autoOk
                                            value={
                                                filtro.competencia_inicial_consumo_comparativo_depois
                                                    ? `${String(filtro.competencia_inicial_consumo_comparativo_depois).substring(0, 4)}/${String(
                                                          filtro.competencia_inicial_consumo_comparativo_depois
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_inicial_consumo_comparativo_depois: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid cols="6 6 6 6">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                        <DatePicker
                                            variant="inline"
                                            openTo="year"
                                            views={["year", "month"]}
                                            label="Até"
                                            autoOk
                                            value={
                                                filtro.competencia_final_consumo_comparativo_depois
                                                    ? `${String(filtro.competencia_final_consumo_comparativo_depois).substring(0, 4)}/${String(
                                                          filtro.competencia_final_consumo_comparativo_depois
                                                      ).substring(4, 6)}/01 12:00:00`
                                                    : null
                                            }
                                            onChange={(value) => {
                                                setFiltro({
                                                    ...filtro,
                                                    competencia_final_consumo_comparativo_depois: value
                                                        ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                        : null,
                                                });
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Row>
                        </Grid>

                        <Grid cols="12 12 2 2" style={{ paddingTop: 10 }}>
                            <Button
                                text="Analisar"
                                type={"primary"}
                                icon={"fa fa-sync"}
                                event={() => {
                                    listar();
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody
                    style={{
                        color: "#fff",
                        backgroundColor: "#30303d",
                        overflowX: "scroll",
                    }}
                >
                    <p id="tituloTabelaComparativa" className="text-center" style={{ fontSize: 16, paddingTop: 20 }}>
                        Tabela Comparativa para Diferentes Períodos (kWh)
                    </p>
                    <div
                        style={{
                            minWidth: "890px",
                        }}
                    >
                        <div className="pb-4">
                            <Toggle
                                checked={considerarConsumoInstantaneoTabelaComparativa}
                                onChange={setConsiderarConsumoInstantaneoTabelaComparativa}
                                fontColor="#FFF"
                                label="Considerar efeito de consumo instantâneo nas UCs com Geração Solar"
                            />
                        </div>
                        <Table responsive id="tabelaComparativa">
                            <THead>
                                <Tr>
                                    <Th>Unidade</Th>
                                    <Th alignCenter>
                                        {filtro.competencia_inicial_consumo_comparativo_antes && filtro.competencia_final_consumo_comparativo_antes
                                            ? `De ${String(filtro.competencia_inicial_consumo_comparativo_antes).substring(4, 6)}/${String(
                                                  filtro.competencia_inicial_consumo_comparativo_antes
                                              ).substring(0, 4)} até ${String(filtro.competencia_final_consumo_comparativo_antes).substring(4, 6)}/${String(
                                                  filtro.competencia_final_consumo_comparativo_antes
                                              ).substring(0, 4)}`
                                            : ""}
                                    </Th>
                                    {!modalExportacaoAberto && <Th></Th>}
                                    <Th alignCenter>Comparativo</Th>
                                    <Th alignCenter>
                                        {filtro.competencia_inicial_consumo_comparativo_depois && filtro.competencia_final_consumo_comparativo_depois
                                            ? `De ${String(filtro.competencia_inicial_consumo_comparativo_depois).substring(4, 6)}/${String(
                                                  filtro.competencia_inicial_consumo_comparativo_depois
                                              ).substring(0, 4)} até ${String(filtro.competencia_final_consumo_comparativo_depois).substring(4, 6)}/${String(
                                                  filtro.competencia_final_consumo_comparativo_depois
                                              ).substring(0, 4)}`
                                            : ""}
                                    </Th>
                                    {!modalExportacaoAberto && <Th></Th>}
                                </Tr>
                            </THead>
                            <TBody>
                                <Tr style={{ minHeight: 30 }} key={"Todas Unidades"}>
                                    <Td color="#fff" backgroundColor="#257bfb">
                                        <b>Todas Unidades</b>
                                    </Td>
                                    <Td alignCenter color="#fff" backgroundColor="#257bfb">
                                        <b>{adicionarPontosMilhar(parseFloat(objetoTotais.valor_anterior || 0).toFixed(2))} kWh</b>
                                    </Td>
                                    {!modalExportacaoAberto && <Td backgroundColor="#257bfb"></Td>}
                                    <Td alignCenter color="#fff" backgroundColor={comparativoTotais == 0 ? "#257bfb" : comparativoTotais > 0 ? "#ef5350" : "#28a745"}>
                                        <b>{parseFloat(objetoTotais.valor_atual) == 0 ? `100,00` : comparativoTotais.toFixed(2).replace(".", ",")}%</b>
                                    </Td>
                                    <Td alignCenter color="#fff" backgroundColor="#257bfb">
                                        <b>{adicionarPontosMilhar(parseFloat(objetoTotais.valor_atual || 0).toFixed(2))} kWh</b>
                                    </Td>
                                    {!modalExportacaoAberto && <Td backgroundColor="#257bfb"></Td>}
                                </Tr>
                                {listaConsumoPorUnidadePeriodoAlterado.map((item) => {
                                    const comparativo = calcularComparativo(item);
                                    return (
                                        <Tr style={{ minHeight: 30 }} key={item.nome_unidade_consumidora}>
                                            <Td color="#fff">{item.nome_unidade_consumidora}</Td>
                                            <Td alignCenter color="#fff">
                                                {adicionarPontosMilhar(parseFloat(item.valor_anterior || 0).toFixed(2))} kWh
                                            </Td>
                                            {!modalExportacaoAberto && (
                                                <Td>
                                                    {item.faturas_anteriores_nao_importadas.length > 0 && (
                                                        <Button
                                                            hoverStyle={{ filter: "brightness(1.1)" }}
                                                            style={{ width: "fit-content", padding: "0px 8px", backgroundColor: "#161920", color: "#ff3131", fontWeight: 500 }}
                                                            text={
                                                                <div style={{ display: "flex" }}>
                                                                    <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                                                    <span style={{ margin: "6px 0 0 6px" }}>Verificar</span>
                                                                </div>
                                                            }
                                                            title="Faltam faturas no período selecionado"
                                                            event={() => {
                                                                setListaModalFaturasSemImportacao(item.faturas_anteriores_nao_importadas);
                                                            }}
                                                        />
                                                    )}
                                                </Td>
                                            )}
                                            <Td alignCenter color="#fff" backgroundColor={comparativo == 0 ? null : comparativo > 0 ? "#ef5350" : "#28a745"}>
                                                {parseFloat(item.valor_atual) == 0 ? `100,00` : comparativo.toFixed(2).replace(".", ",")}%
                                            </Td>
                                            <Td alignCenter color="#fff">
                                                {adicionarPontosMilhar(parseFloat(item.valor_atual || 0).toFixed(2))} kWh
                                            </Td>
                                            {!modalExportacaoAberto && (
                                                <Td>
                                                    {item.faturas_atuais_nao_importadas.length > 0 && (
                                                        <Button
                                                            hoverStyle={{ filter: "brightness(1.1)" }}
                                                            style={{ width: "fit-content", padding: "0px 8px", backgroundColor: "#161920", color: "#ff3131", fontWeight: 500 }}
                                                            text={
                                                                <div style={{ display: "flex" }}>
                                                                    <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                                                    <span style={{ margin: "6px 0 0 6px" }}>Verificar</span>
                                                                </div>
                                                            }
                                                            title="Faltam faturas no período selecionado"
                                                            event={() => {
                                                                setListaModalFaturasSemImportacao(item.faturas_atuais_nao_importadas);
                                                            }}
                                                        />
                                                    )}
                                                </Td>
                                            )}
                                        </Tr>
                                    );
                                })}
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ padding: 8 }}>
                <ContentCardHeader>
                    <Select
                        name="ano"
                        options={listaAnos}
                        label="Ano"
                        cols="12 6 3"
                        placeholder="Selecione o ano"
                        value={filtro.ano_acumulado_consumo}
                        isClearable={false}
                        isSearchable={false}
                        onChange={(value) => {
                            setFiltro({
                                ...filtro,
                                ano_acumulado_consumo: value,
                            });
                            listar();
                        }}
                    />
                </ContentCardHeader>
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "scroll", maxHeight: 400 }}>
                    <div id="periodoConsumoPorUnidadeAcumuladoAno" style={{ visibility: "hidden", display: "flex", justifyContent: "center" }}>
                        <h4>{`Consumo Acumulado por UC em ${filtro.ano_acumulado_consumo} (kWh)`}</h4>
                    </div>
                    {modalExportacaoAberto && (
                        <Table
                            responsive
                            id="tabelaConsumoPorUnidadeAcumuladoAno"
                            height={(listaGraficoConsumoPorUnidadeAcumuladoAno || []).length * 50 < 400 ? 400 : listaGraficoConsumoPorUnidadeAcumuladoAno.length * 50}
                        >
                            <THead>
                                <Tr>
                                    <Th>Unidade</Th>
                                    <Th></Th>
                                    <Th alignCenter>Na Fatura (kWh)</Th>
                                    <Th alignCenter>Cons. Inst. (kWh)</Th>
                                </Tr>
                            </THead>
                            <TBody>
                                {[...listaGraficoConsumoPorUnidadeAcumuladoAno]
                                    .sort((a, b) => b.consumo_fatura - a.consumo_fatura)
                                    .map((item) => {
                                        const menorConsumoInstantaneo = listaGraficoConsumoPorUnidadeAcumuladoAno.reduce(
                                            (acc, atual) => Math.min(acc, atual.consumo_instantaneo || 0),
                                            0
                                        );

                                        const max =
                                            listaGraficoConsumoPorUnidadeAcumuladoAno.reduce(
                                                (acc, atual) => Math.max(acc, (atual.consumo_fatura || 0) + (atual.consumo_instantaneo >= 0 ? atual.consumo_instantaneo : 0)),
                                                0
                                            ) + Math.abs(menorConsumoInstantaneo); //soma a maior barra possível com a menor, para saber qual espaço maximo que pode ocupar

                                        const barraPercentualMenorConsumoInstantaneo = Math.round(max > 0 ? (Math.abs(menorConsumoInstantaneo) / max) * 100 : 0);
                                        const barraPercentual = Math.round(max > 0 ? (parseFloat(item.consumo_fatura || 0) / max) * 100 : 0);
                                        const consumoInstantaneo = parseFloat(item.consumo_instantaneo || 0);
                                        const barraPercentualConsumoInstantaneo = Math.round(max > 0 ? (Math.abs(consumoInstantaneo) / max) * 100 : 0);

                                        // // Intervalos de hue possíveis (neon azul/roxo/lilás + verde/amarelo fosforescente)
                                        // const hueRanges = [
                                        //     [200, 300], // azul → roxo → lilás
                                        //     [70, 110], // verde-limão / amarelo-esverdeado fluorescente
                                        // ];

                                        // // Escolhe aleatoriamente um dos intervalos
                                        // const [minHue, maxHue] = hueRanges[Math.floor(Math.random() * hueRanges.length)];
                                        // const hue = minHue + Math.floor(Math.random() * (maxHue - minHue));

                                        // const saturation = 90 + Math.floor(Math.random() * 10); // 90–100%
                                        // const lightness = 60 + Math.floor(Math.random() * 20); // 60–80%

                                        // const cor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

                                        const corConsumoFatura = "#009de6";
                                        const corConsumoInstantaneo = "#4e2dee";

                                        return (
                                            <Tr key={item.agrupador}>
                                                <Td color="#fff">{item.agrupador}</Td>
                                                <Td width="40vw">
                                                    <div style={{ display: "flex" }}>
                                                        {consumoInstantaneo < 0 ? (
                                                            <>
                                                                <div
                                                                    style={{
                                                                        minWidth: barraPercentualMenorConsumoInstantaneo - barraPercentualConsumoInstantaneo + "%",
                                                                        height: 20,
                                                                    }}
                                                                ></div>
                                                                <div
                                                                    style={{
                                                                        backgroundColor: corConsumoInstantaneo,
                                                                        minWidth: barraPercentualConsumoInstantaneo + "%",
                                                                        height: 20,
                                                                    }}
                                                                ></div>
                                                            </>
                                                        ) : (
                                                            <div style={{ minWidth: barraPercentualMenorConsumoInstantaneo + "%", height: 20 }}></div>
                                                        )}
                                                        <div style={{ backgroundColor: corConsumoFatura, minWidth: barraPercentual + "%", height: 20 }}></div>
                                                        {consumoInstantaneo > 0 && (
                                                            <div
                                                                style={{ backgroundColor: corConsumoInstantaneo, minWidth: barraPercentualConsumoInstantaneo + "%", height: 20 }}
                                                            ></div>
                                                        )}
                                                    </div>
                                                </Td>
                                                <Td alignCenter color="#fff">
                                                    {adicionarPontosMilhar(parseFloat(item.consumo_fatura || 0).toFixed(2))} kWh
                                                </Td>
                                                <Td alignCenter color="#fff">
                                                    {adicionarPontosMilhar(parseFloat(item.consumo_instantaneo || 0).toFixed(2))} kWh
                                                </Td>
                                            </Tr>
                                        );
                                    })}
                            </TBody>
                        </Table>
                    )}
                    {!modalExportacaoAberto && (
                        <div
                            id="graficoConsumoPorUnidadeAcumuladoAno"
                            style={{
                                width: "100%",
                                minWidth: 900,
                                height: (listaGraficoConsumoPorUnidadeAcumuladoAno || []).length * 50 < 400 ? 400 : listaGraficoConsumoPorUnidadeAcumuladoAno.length * 50,
                            }}
                        ></div>
                    )}
                </ContentCardBody>
            </ContentCard>
        </div>
    );

    function ExportAnalise() {
        const [graficosAtivos, setGraficosAtivos] = useState({
            graficoConsumoAnual: true,
            graficoConsumoMensal: true,
            tabelaConsumoMensal: true,
            tabelaComparativa: true,
            graficoConsumoPorUnidadeAcumuladoAno: true,
        });

        const todosMarcados =
            graficosAtivos.graficoConsumoAnual &&
            graficosAtivos.graficoConsumoMensal &&
            graficosAtivos.tabelaConsumoMensal &&
            graficosAtivos.tabelaComparativa &&
            graficosAtivos.graficoConsumoPorUnidadeAcumuladoAno;

        const existeAlgumMarcado =
            graficosAtivos.graficoConsumoAnual ||
            graficosAtivos.graficoConsumoMensal ||
            graficosAtivos.tabelaConsumoMensal ||
            graficosAtivos.tabelaComparativa ||
            graficosAtivos.graficoConsumoPorUnidadeAcumuladoAno;

        return (
            <>
                <div className="d-flex flex-column justify-content-center align-items-center text-dark">
                    <p>Selecione os gráficos que deseja exportar</p>
                </div>
                <LabelAndCheckbox
                    style={{ color: todosMarcados ? "#c90028" : "#1454ff", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem", marginBottom: 25 }}
                    label={todosMarcados ? "Desmarcar Todos" : "Marcar Todos"}
                    onChange={(e) =>
                        setGraficosAtivos({
                            graficoConsumoAnual: todosMarcados ? false : true,
                            graficoConsumoMensal: todosMarcados ? false : true,
                            tabelaConsumoMensal: todosMarcados ? false : true,
                            tabelaComparativa: todosMarcados ? false : true,
                            graficoConsumoPorUnidadeAcumuladoAno: todosMarcados ? false : true,
                        })
                    }
                    value={todosMarcados}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoConsumoAnualCheckbox"
                    label="Consumo Total (kWh)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoConsumoAnual: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoConsumoAnual}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoConsumoMensalCheckbox"
                    label="Consumo Mensal (kWh)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoConsumoMensal: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoConsumoMensal}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="tabelaComparativaCheckbox"
                    label="Tabela Comparativa para Diferentes Períodos (kWh)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            tabelaComparativa: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.tabelaComparativa}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoConsumoPorUnidadeAcumuladoAnoCheckbox"
                    label="Consumo Acumulado por UC (kWh)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoConsumoPorUnidadeAcumuladoAno: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoConsumoPorUnidadeAcumuladoAno}
                />

                <Row alignRight style={{ paddingRight: 5 }}>
                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Exportar</span>}
                            type={"info"}
                            icon={"fas fa-check"}
                            event={async (e) => {
                                if (!existeAlgumMarcado) {
                                    return setInfo("Marque pelo menos um item para exportar");
                                }
                                await handleExport({ graficosAtivos, quantidadeAnos, quantidadeUCs });
                                setModalExportacaoAberto(false);
                            }}
                        />
                    </Grid>

                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Cancelar</span>}
                            type={"danger"}
                            event={() => setModalExportacaoAberto(false)}
                        />
                    </Grid>
                </Row>
            </>
        );
    }

    function calcularSazonalidade({ anoCalculoIndiceSazonal }) {
        let listaSazonalidade = [];
        //altera o calculo conforme edita os valores
        listaConsumoEditavel.forEach((item) => {
            item.anos.forEach((itemMes) => {
                const anoComparacao = filtro.consumo_ano_safra
                    ? parseInt(itemMes.mes) >= 6
                        ? `${String(itemMes.ano).substring(0, 4)}`
                        : `${String(itemMes.ano).substring(5)}`
                    : itemMes.ano;
                listaSazonalidade.push({
                    competencia: parseInt(`${anoComparacao}${itemMes.mes}`),
                    valor: itemMes.consumo_fatura,
                });
            });
        });

        //SAZONALIADE = (SOMA DOS QUATRO MENORES) DIVIDIDO (SOMA DOS QUATRO MAIORES), DOS ULTIMOS 12 MESES
        if (contratoDemanda) {
            //não sazonal só calcula pro ano atual
            if (!ucFiltradaSazonal && anoAtual != anoCalculoIndiceSazonal) return "-";

            let demandaInicio = parseInt(`${demandaMesInicial == "01" ? anoCalculoIndiceSazonal : anoCalculoIndiceSazonal - 1}${demandaMesInicial}`);
            let demandaFim = parseInt(`${anoCalculoIndiceSazonal}${demandaMesFinal}`);

            //se for não sazonal altera o inicio e fim
            if (!ucFiltradaSazonal && anoAtual == anoCalculoIndiceSazonal) {
                demandaInicio = demandaCompetenciaInicial;
                demandaFim = demandaCompetenciaFinal;
            }

            //se for de 01/22 a 12/22 mostra 2022, se for 04/22 a 03/23 mostra 22/23
            const ciclo =
                demandaAnoInicial == demandaAnoFinal
                    ? `${anoCalculoIndiceSazonal}`
                    : `${demandaMesInicial}/${String(anoCalculoIndiceSazonal - 1)} à ${demandaMesFinal}/${String(anoCalculoIndiceSazonal)}`;

            //se o for não sazonal, sobreescreve o demandaInicio e demandaFim

            //separa só as 12 que devem ser consideradas
            listaSazonalidade = listaSazonalidade
                .filter((item) => item.competencia >= demandaInicio && item.competencia <= demandaFim)
                .sort((a, b) => Number(a.competencia) - Number(b.competencia))
                .splice(-12)
                .sort((a, b) => a.valor - b.valor); //ordena para as 4 com menor valor ficar no inicio e as 4 maiores no final
            // só calcula se tiver no mínimo 8 valores
            if (listaSazonalidade.length < 8) {
                return (
                    <>
                        <div>{`${ciclo}:`}</div>
                        <div style={{ paddingInline: 14 }}>-</div>
                    </>
                );
            }

            let menores = 0;
            for (let i = 0; i < 4; i++) {
                //   console.log("menor -> ", listaSazonalidade[i]);
                menores += listaSazonalidade[i].valor;
            }
            let maiores = 0;
            for (let i = listaSazonalidade.length - 1; i >= listaSazonalidade.length - 4; i--) {
                //   console.log("maior -> ", listaSazonalidade[i]);
                maiores += listaSazonalidade[i].valor;
            }

            //   console.log(listaSazonalidade);
            //se estiver iterando

            return (
                <>
                    <div>{`${ciclo}:`}</div>
                    <div
                        style={{
                            color: parseFloat(menores / maiores) <= 0.2 ? "#3f3" : "#fff",
                            fontWeight: parseFloat(menores / maiores) <= 0.2 ? "bold" : "normal",
                        }}
                    >
                        {` ${parseFloat(menores / maiores)
                            .toFixed(2)
                            .replace(".", ",")}
                                                                          `}
                    </div>
                </>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    filtro: state.analise.filtro,
    usuarioLogado: state.auth.usuarioLogado,
    contratoDemanda: state.analise.contratoDemanda,
    listaGraficoConsumoAnual: state.analise.listaGraficoConsumoAnual,
    listaUnidadeConsumidora: state.analise.listaUnidadeConsumidora,
    listaConsumoPorUnidadePeriodo: state.analise.listaConsumoPorUnidadePeriodo,
    listaGraficoConsumoPorUnidadeAcumuladoAno: state.analise.listaGraficoConsumoPorUnidadeAcumuladoAno,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDemanda,
            getListaGraficoConsumoAnual,
            getListaConsumoPorUnidadePeriodo,
            getListaGraficoConsumoPorUnidadeAcumuladoAno,
            setFiltro,
            gerarRelatorio,
            setListaFaturasRedirecionamento,
        },
        dispatch
    );
const AnaliseConsumo = withRouter(connect(mapStateToProps, mapDispatchToProps)(analiseConsumo));
export { AnaliseConsumo };
